import axios from "axios";

var _runtime_env = {};

const env = () => {
  return _runtime_env;
};

Object.defineProperty(window, "env", { get: env });

export const loadEnvironmentVariables = async () => {
  // load default env from .env
  for (const [key, value] of Object.entries(process.env)) {
    _runtime_env[key] = value;
  }
  if (process.env.NODE_ENV !== "development") {
    const res = await axios.get("/config.env");
    const dotenv = require("dotenv");
    const buf = Buffer.from(res.data);
    const config = dotenv.parse(buf);
    _runtime_env = Object.assign(_runtime_env, config);
  }
  return _runtime_env;
};
